import logo from "../../resources/logo.svg"


const NotFound = () => {
    return (
        <div className="validation-form">
            <img src={logo} alt="Company Logo" className="logo" />
            <h2 className="app-title">SMARTBAR</h2>
            <div className="status-message error">Die von Ihnen gesuchte Seite existiert nicht. Bitte starten Sie einen neuen Vorgang, indem Sie einen unserer Mitarbeiter kontaktieren.</div>
        </div>
    )
}

export default NotFound;
